import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogFullScreenComponentContent } from '@toro/common/shared/models/dialogs/dialog-full-screen';
import { Component, ElementRef, Inject, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { FinanceActions } from '@toro/common/shared/state-management/finance/finance.action';
import { WithdrawExecutionDate } from '@toro/common/shared/models/finance/withdraw-execution-date.model';
import { SuitabilityAnticipationDialogComponent } from '../../home-logged/dialogs/suitability-santander-anticipation-dialog/suitability-anticipation-dialog.component';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { SantanderSuitabilityService } from '@toro/common/shared/services/santander-suitability/santander-suitability-service';
import { filter } from 'rxjs/operators';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { SuitabilitySantanderAction } from '@toro/common/shared/state-management/suitability-santander/suitability-santander.action';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

// tslint:disable-next-line
interface IdialogData {
    value: number | string;
    bankAccount: {
        bankId: number | string;
        agency: number | string;
        number: number | string;
        typeDescription: string;
        digit: number | string;
    };
    bankName: string;
    hasAccountCommunicationActive?: boolean;
}

@AutoUnsubscribe()
@Component({
    selector: 'draftsuccess',
    templateUrl: './draftsuccess.component.html',
    styleUrls: ['./draftsuccess.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DraftSuccessComponent extends DialogFullScreenComponentContent implements OnDestroy {

    public logoPath = `/assets/images/${environment.isNewBrand ? 'santander': 'toro'}-red-black-small.svg`;
    public withdrawExecutionDate: WithdrawExecutionDate;
    public hasSuitabilitySantanderProfile: boolean;
    public isExcludedFromSuitabilityCommunication: boolean;
    public suitabilitySantanderSubscription: Subscription;
    public suitabilityDialogSubscription: Subscription;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public dialogData: IdialogData,
        public element: ElementRef,
        private router: Router,
        private dialogReference: MatDialogRef<DraftSuccessComponent>,
        public store: Store<AppState>,
        private santanderSuitabilityService: SantanderSuitabilityService,
        private dialogsService: DialogsService,

    ) {
        super(element);
        this.withdrawExecutionDate = new WithdrawExecutionDate();
        this.store.dispatch({ type: FinanceActions.getTransferExecutionDate });
        this.store.dispatch({ type: SuitabilitySantanderAction.checkClientExcludeFromCommunication });
    }

    public ngOnInit() {
        this.getWithdrawExecutionDate();

        this.suitabilitySantanderSubscription = this.store
            .select((state) => state.suitabilitySantander)
            .pipe(filter((r) => !!r))
            .subscribe((r) => {
                this.hasSuitabilitySantanderProfile = r.profile.profileName && r.profile.profileName.trim() !== '';
                this.isExcludedFromSuitabilityCommunication = r.isExcludedFromCommunication;
            }
            );
    }

    public showSuitabilityAnticipationModal() {
        const isTrader = this.santanderSuitabilityService.getClientSegment() == 'Trader';
        const shouldShowModal = this.santanderSuitabilityService.mustShowCommunication() && isTrader && !this.isExcludedFromSuitabilityCommunication;

        if (shouldShowModal && !this.hasSuitabilitySantanderProfile) {
            this.suitabilityDialogSubscription = this.dialogsService.showComponnent(SuitabilityAnticipationDialogComponent, {
                isTrader: this.santanderSuitabilityService.getClientSegment() == 'Trader',
                productAreaOrigin: 'Saque'
            })
                .afterClosed()
                .subscribe(() => { })
        }
    }

    /**
     *
     * loads WithdrawExecutionDate from VF into withdrawExecutionDate var
     */
    public getWithdrawExecutionDate() {
        this.store.select(x => x.finance)
            .subscribe((finance) => {
                this.withdrawExecutionDate = finance.withdrawExecutionDate;
            });
    }

    // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    // tslint:disable-next-line:no-empty
    public ngOnDestroy() { }

    /**
     * Fecha o dialogo
     * direciona o cliente para a home logada
     */
    public dispose() {
        this.router
            .navigate(['/'])
            .then(() => {
                this.dialogReference.close();
                this.showSuitabilityAnticipationModal();
            });
    }
}
